// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ybqC","title":"Info_title__2qfTw","links":"Info_links__UDo1q","link":"Info_link__1yRR8","logo":"Info_logo__1kLZN"};